// 老师端- 场馆旧址
import services from '../assets/js/services'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    // 获取场馆类型列表
    getStadiumAddress (context, payload) {
      return services.getStadiumAddress(payload).then(res => {
        return res;
      })
    },
    // 场馆类型添加
    addStadiumAddress (context, payload) {
      return services.addStadiumAddress(payload).then(res => {
        return res;
      })
    },
    //  场馆类型编辑、删除
    editStadiumAddress (context, payload) {
      return services.editStadiumAddress(payload).then(res => {
        return res;
      })
    },
    //  场馆类型详情
    getStadiumAddressInfo (context, payload) {
      return services.getStadiumAddressInfo(payload).then(res => {
        return res;
      })
    },
       // 获取文物列表
    getSartifact (context, payload) {
      return services.getSartifact(payload).then(res => {
        return res;
      })
    },
    // 文物添加
    addSartifact (context, payload) {
      return services.addSartifact(payload).then(res => {
        return res;
      })
    },
    //  文物编辑、删除
    editSartifact (context, payload) {
      return services.editSartifact(payload).then(res => {
        return res;
      })
    },
    //  文物详情
    getSartifactInfo (context, payload) {
      return services.getSartifactInfo(payload).then(res => {
        return res;
      })
    },
          // 获取人物列表
    getCharacter (context, payload) {
      return services.getCharacter(payload).then(res => {
        return res;
      })
    },
    // 人物添加
    addCharacter (context, payload) {
      return services.addCharacter(payload).then(res => {
        return res;
      })
    },
    //  人物编辑、删除
    editCharacter (context, payload) {
      return services.editCharacter(payload).then(res => {
        return res;
      })
    },
    //  人物详情
    getCharacterInfo (context, payload) {
      return services.getCharacterInfo(payload).then(res => {
        return res;
      })
    },
          // 获取人物列表
    getHall (context, payload) {
      return services.getHall(payload).then(res => {
        return res;
      })
    },
    // 人物添加
    addHall (context, payload) {
      return services.addHall(payload).then(res => {
        return res;
      })
    },
    //  人物编辑、删除
    getHallInfo (context, payload) {
      return services.getHallInfo(payload).then(res => {
        return res;
      })
    },
    //  人物详情
    editHall (context, payload) {
      return services.editHall(payload).then(res => {
        return res;
      })
    },
  },
  mutations: {
  }
}